<div [class]="containerClass()">
  <!-- DOM order encodes the anime.stagger delay sequence (0ms, 600ms,
       1200ms). Sparkles are absolute-positioned, so this order has no
       visual effect — it only sequences the animation. -->
  <img
    src="assets/icons/ai-sparkle.svg"
    alt=""
    class="sparkle absolute top-0 left-4 w-10 h-10" />
  <img
    src="assets/icons/ai-sparkle.svg"
    alt=""
    class="sparkle absolute top-3 left-0 w-4 h-4" />
  @if (isWelcome()) {
    <img
      src="assets/icons/ai-sparkle.svg"
      alt=""
      class="sparkle absolute bottom-0 left-1.5 w-5 h-5" />
  }
</div>
